const $ = require('jquery');

window.$ = $;
window.jQuery = $;

require('jquery-migrate');

const moment = require('moment');

window.moment = moment;

const bootstrap = require('bootstrap');

window.bootstrap = bootstrap;

const installBootstrapLegacyBridge = require('./bootstrap-legacy-bridge.cjs');
const installDateTimePickerBridge = require('./datetimepicker-legacy-bridge.cjs');

function getLanguage() {
  return document.documentElement.getAttribute('data-app-language') || 'en';
}

function loadMomentLocale(language) {
  const localeMap = {
    de: () => require('moment/locale/de'),
    es: () => require('moment/locale/es'),
    fr: () => require('moment/locale/fr'),
    it: () => require('moment/locale/it'),
    lt: () => require('moment/locale/lt'),
    nl: () => require('moment/locale/nl'),
    pt: () => require('moment/locale/pt'),
    ru: () => require('moment/locale/ru')
  };

  if (localeMap[language]) {
    localeMap[language]();
    moment.locale(language);
  }
}

function loadValidatorLocale(language) {
  const localeMap = {
    de: () => require('jquery-validation/dist/localization/messages_de'),
    es: () => require('jquery-validation/dist/localization/messages_es'),
    fr: () => require('jquery-validation/dist/localization/messages_fr'),
    it: () => require('jquery-validation/dist/localization/messages_it'),
    lt: () => require('jquery-validation/dist/localization/messages_lt'),
    nl: () => require('jquery-validation/dist/localization/messages_nl'),
    pt: () => require('jquery-validation/dist/localization/messages_pt_PT')
  };

  if (localeMap[language]) {
    localeMap[language]();
  }
}

function loadAppLocalization(language) {
  const localeMap = {
    de: () => require('../../public/js/localization/de.js'),
    en: () => require('../../public/js/localization/en.js'),
    es: () => require('../../public/js/localization/es.js'),
    fr: () => require('../../public/js/localization/fr.js'),
    it: () => require('../../public/js/localization/it.js'),
    nl: () => require('../../public/js/localization/nl.js'),
    pt: () => require('../../public/js/localization/pt.js')
  };

  const loader = localeMap[language] || localeMap.en;
  loader();
}

module.exports = function initializeApp(options) {
  const anonymous = Boolean(options && options.anonymous);
  const language = getLanguage();

  window.appLanguage = language;

  loadMomentLocale(language);
  installBootstrapLegacyBridge($, bootstrap);

  require('../../public/js/stacktrace-min-0.4.js');

  const bootbox = require('bootbox');
  window.bootbox = bootbox;

  require('../../public/js/errorhandler.js');

  require('jquery-validation');
  loadValidatorLocale(language);

  if (anonymous) {
    require('../../public/js/anonymous_apt.js');
    return;
  }

  const DataTable = require('datatables.net-bs5');
  $.extend(true, DataTable.defaults, {
    dom: "t<'row tablefooter'<'col-md-5'l i><'col-md-7'p>>",
    pagingType: 'simple_numbers',
    renderer: 'bootstrap'
  });

  $.extend(DataTable.ext.classes, {
    sFilterInput: 'form-control input-sm',
    sLengthSelect: 'form-control input-sm',
    sWrapper: 'dataTables_wrapper form-inline dt-bootstrap'
  });
  require('inputmask/dist/jquery.inputmask.js');

  require('bootstrap-fileinput');
  require('bootstrap-fileinput/themes/bs5/theme.js');
  require('bootstrap-fileinput/themes/fa6/theme.js');

  if ($.fn.fileinput && $.fn.fileinput.defaults) {
    $.fn.fileinput.defaults.theme = 'fa6';
  }

  require('bootstrap-notify');
  require('../../public/js/toggles.min.js');

  installDateTimePickerBridge($, moment);
  loadAppLocalization(language);

  require('../../public/js/functions.js');
  require('../../public/js/apt.js');
};
